import { render } from "./App.vue?vue&type=template&id=b8773cc2&ts=true"
import script from "./App.vue?vue&type=script&lang=ts"
export * from "./App.vue?vue&type=script&lang=ts"

import "./scss/main.scss?vue&type=style&index=0&lang=scss"

import exportComponent from "/home/runner/work/jh8oh.github.io/jh8oh.github.io/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__